// G5 Prix réglementés et observations (interface) : inscription du module. Les fichiers centraux (routeur,
// pages, navigation) reçoivent une ligne par module à l'intégration.

import { createElement } from 'react';
import { PagePrix } from './Prix';

export const inscription = {
  code: 'G5',
  routes: [{ chemin: '/prix', element: createElement(PagePrix) }],
} as const;
